import { toast, useToast } from '@chakra-ui/react';
import { stat } from 'fs';
import { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { apiSensedia } from '../../../../../services/api-sensedia';
import { CardDestination } from '../components/CardDestination';
import { CardOrigin } from '../components/CardOrigin';
import { ConfirmationModal } from '../components/ConfirmationModal';
import { SubmitButtonSession } from '../components/SubmitButtonSession';
import { WarningTextBox } from '../components/WarningTextBox';
import { useMovimentacaoFundos } from '../hooks/useMovimentacaoFundos';
import { LayoutMovimentacaoFundos } from '../layouts/LayoutMovimentacaoFundos';
import { FundoDestinoType } from '../types/MovimentacaoFundosType';
import { getOriginPercentage } from '../utils/getOriginPercentage';

export const TransferindoPercentuais = () => {
  let apiMf = apiSensedia;

  if (process.env.NODE_ENV != 'development') {
    apiMf = apiSensedia;
  }

  const navigate = useNavigate();
  const { state } = useMovimentacaoFundos();
  const { idFund } = useParams();
  const toast = useToast();

  const fundosDestinoRef = useRef<HTMLDivElement>();
  const fundoOrigemRef = useRef<HTMLDivElement>();

  const [isOriginFundSelected, setIsOriginFundSelected] = useState(false);

  const [destinationFundList, setDestinationFundList] = useState([]);
  const [destinationFundSelectedList, setDestinationFundSelectedList] =
    useState<
      {
        name: string;
        value: any;
      }[]
    >([
      {
        name: '',
        value: 0
      }
    ]);

  const [originFundValuePercentage, setOriginFundValuePercentage] = useState(0);
  const [
    destinationFundValuePercentageTotal,
    setDestinationFundValuePercentageTotal
  ] = useState(0);

  const [isSubmitButtonDisabled, setIsSubmitButtonDisebled] = useState(false);
  const [
    isConfirmationModalForSubmitOpened,
    setIsConfirmationModalForSubmitOpened
  ] = useState(false);

  const [
    isConfirmationModalForCancelOpened,
    setIsConfirmationModalForCancelOpened
  ] = useState(false);

  const [fundosDestinoList, setFundosDestinoList] = useState<
    FundoDestinoType[]
  >([]);

  const contentWarningTextBox =
    ' Você precisa preencher o campo {[Origem - % de transferência]} e preencher @ um ou mais campos {[Destino/fundos - % de transferência]} para poder liberar o botão submeter';

  const getData = async () => {
    let looping = true;
    while (looping) {
      try {
        const res = await apiMf.get(
          `/movimentacoes-fundos/propostas/${state.numero_proposta}/contratos/${state.id_contrato}/fundos-destino`,
          {
            headers: {
              cpf: state.cpf,
              'id-fundo-origem': state.id_fundo_origem
            }
          }
        );

        let fundosDestino: FundoDestinoType[] = res.data;

        fundosDestino = fundosDestino.map((el: FundoDestinoType) => {
          return {
            ...el,
            valor: 0
          };
        });

        console.log('lista fundos destino', fundosDestino);

        setFundosDestinoList(fundosDestino);

        looping = false;
      } catch (e: any) {
        if (e.response.status == 500) {
          console.log('ocorreu internal server error', e.response.statusText);
          console.log('ocorreu internal server error', e.response.data);
        } else if (e.response.status == 504) {
          console.log('ocorreu gateway timeout', e.response.data);
        }
        if (e.response.status != 504) {
          looping = false;
        }
      }
    }
  };

  const handleInputChangeOriginFund = (value: number) => {
    setOriginFundValuePercentage(Number(value));

    console.log('valor percentual', value);

    setIsOriginFundSelected(value > 0 && value <= 100);
  };

  const handleInputChangeDestinationFund = (index, value, event) => {
    const updatedInputs = [...fundosDestinoList];
    console.log(
      'value',
      value,
      'fundosDestinoList[index].valor',
      fundosDestinoList[index].valor
    );

    const diff = value - fundosDestinoList[index].valor;

    const sum = destinationFundValuePercentageTotal + diff;

    if (event.key === 'Backspace') {
      updatedInputs[index].valor = 0;
      setFundosDestinoList(updatedInputs);

      const newArray = updatedInputs.map((val) => val.valor);
      const newSum = newArray.reduce((a, b) => a + b);
      setDestinationFundValuePercentageTotal(newSum);
      return;
    }

    if (sum <= 100) {
      updatedInputs[index].valor = value;
      setFundosDestinoList(updatedInputs);
      setDestinationFundValuePercentageTotal(sum);
    } else {
      toast({
        position: 'top',
        description:
          'Percentual de transferência não pode ser superior a 100%, revise as porcentagens nos fundos de destino e tente novamente',
        status: 'warning',
        duration: 4000,
        isClosable: true
      });
    }
  };

  const handleIncrementPercentage = (value: number, ref: string) => {
    if (ref != 'origin') {
      const updatedInputs = [...fundosDestinoList];
      if (destinationFundValuePercentageTotal < 100) {
        updatedInputs[value].valor += 1;
        setFundosDestinoList(updatedInputs);
        setDestinationFundValuePercentageTotal(
          destinationFundValuePercentageTotal + 1
        );
      } else {
        toast({
          position: 'top',
          description:
            'Percentual de transferência não pode ser superior a 100%, revise as porcentagens nos fundos de destino e tente novamente',
          status: 'warning',
          duration: 4000,
          isClosable: true
        });
      }
    } else {
      if (value < 100) {
        setOriginFundValuePercentage(value + 1);
        setIsOriginFundSelected(true);
        console.log(
          value,
          originFundValuePercentage,
          Number(getOriginPercentage(String(value + 1)).toFixed(2))
        );
      }
    }
  };

  const handleDecrementPercentage = (value: number, ref: string) => {
    if (ref != 'origin') {
      const updatedInputs = [...fundosDestinoList];
      if (updatedInputs[value].valor > 0) {
        updatedInputs[value].valor -= 1;
        setFundosDestinoList(updatedInputs);
        setDestinationFundValuePercentageTotal(
          destinationFundValuePercentageTotal - 1
        );
      }
    } else {
      value - 1 === 0 && setIsOriginFundSelected(false);
      if (value > 0) {
        setOriginFundValuePercentage(value - 1);
      }
    }
  };

  const handleButtonSubmitDisabled = () => {
    if (destinationFundValuePercentageTotal === 100) {
      setIsSubmitButtonDisebled(false);
    } else {
      setIsSubmitButtonDisebled(true);
    }
  };

  const handleModalConfirmation = (res: string) => {
    switch (res) {
      case 'open-submit-modal':
        setIsConfirmationModalForSubmitOpened(true);
        break;
      case 'close-submit-modal':
        setIsConfirmationModalForSubmitOpened(false);
        break;
      case 'open-cancel-modal':
        setIsConfirmationModalForCancelOpened(true);
        break;
      case 'close-cancel-modal':
        setIsConfirmationModalForCancelOpened(false);
        break;
      default:
        break;
    }
  };

  const createSugestaoMovimentacao = async (action: string) => {
    if (action === 'submit') {
      //Criar sugestao aqui
      const listObjFundosDestino = Array.from(
        fundosDestinoRef.current.querySelectorAll('.linha-fundo-destino')
      )
        .filter((el: Element) => {
          const inputEL = el.querySelector(
            '.input-percentual-fundo'
          ) as HTMLInputElement;
          return Number(inputEL.value) > 0 && Number(inputEL.value) <= 100;
        })
        .map((el: Element) => {
          const inputEL = el.querySelector(
            '.input-percentual-fundo'
          ) as HTMLInputElement;

          const arrIdParts = el.id.split('-');
          const idFundo = Number(arrIdParts[arrIdParts.length - 1]);
          const percentualEntrada = Math.abs(Number(inputEL.value));

          return {
            id_fundo_destino: idFundo,
            id_contrato: state.id_contrato,
            percentual_entrada: percentualEntrada
          };
        });

      //Validando uma segunda vez a soma dos percentuais
      let somaPercentuais = 0;

      listObjFundosDestino.forEach((el) => {
        somaPercentuais += el.percentual_entrada;
      });

      if (!somaPercentuais || somaPercentuais !== 100) {
        toast({
          position: 'top',
          description:
            'A soma dos percentuais dos fundos destino não estão igualando 100%. Favor corrigir.',
          status: 'warning',
          duration: 4000,
          isClosable: true
        });
        return;
      }

      const percentualFundOrigem = Number(
        (
          fundoOrigemRef.current.querySelector(
            '.input-percentual-fundo'
          ) as HTMLInputElement
        ).value
      );

      if (!percentualFundOrigem) {
        toast({
          position: 'top',
          description:
            'O percentual do fundo origem não pode ser 0. Favor corrigir.',
          status: 'warning',
          duration: 4000,
          isClosable: true
        });
        return;
      }

      const objSugestao = {
        id_contrato: Number(state.id_contrato),
        cpf_cliente: state.cpf.trim(),
        numero_proposta: Number(state.numero_proposta),
        telefone_cliente: state.telefone?.trim(),
        ev: state.ev,
        fundo_origem: {
          id_fundo_origem: Number(state.id_fundo_origem),
          saldo_inicial: Number(state.saldo_inicial),
          codigo_conta: null,
          percentual_saida_origem: Number(percentualFundOrigem)
        },
        fundos_destino: listObjFundosDestino
      };

      console.log('obj sugestão', objSugestao);

      try {
        await apiMf.post(
          '/movimentacoes-fundos/sugestoes-movimentacao',
          objSugestao
        );

        setIsConfirmationModalForSubmitOpened(false);

        navigate(
          `/corretor/previdencia-individual/movimentacao-fundos/conclusao`,
          {
            replace: true
          }
        );
      } catch (e: any) {
        console.log(e.response);

        toast({
          position: 'top',
          description: e.response?.data?.message?.toString(),
          status: 'error',
          duration: 4000,
          isClosable: true
        });

        setIsConfirmationModalForSubmitOpened(false);
      }
    } else {
      setIsConfirmationModalForSubmitOpened(false);
    }
  };

  const handleCancellationConfirmation = (action: string) => {
    if (action === 'submit') {
      navigate(
        '/corretor/previdencia-individual/movimentacao-fundos/analitico-proposta'
      );
      setIsConfirmationModalForCancelOpened(false);
    } else {
      setIsConfirmationModalForCancelOpened(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    handleButtonSubmitDisabled();
    console.log(
      'total percentual destino',
      destinationFundValuePercentageTotal
    );
  }, [destinationFundValuePercentageTotal]);

  return (
    <LayoutMovimentacaoFundos
      navigate={() => {
        navigate(
          '/corretor/previdencia-individual/movimentacao-fundos/analitico-proposta'
        );
      }}
    >
      <div className="tw-flex tw-flex-col tw-justify-center tw-items-center tw-w-full tw-max-w-6xl tw-bg-white tw-rounded-lg tw-shadow-md tw-mb-5">
        <div className="tw-w-full tw-flex tw-justify-center tw-pt-5">
          <WarningTextBox content={contentWarningTextBox} />
        </div>
        <div className="tw-w-full tw-h-auto tw-flex tw-justify-between tw-max-w-[905px] tw-overflow-y-auto tw-scrollbar-customized">
          <CardOrigin
            parentRef={fundoOrigemRef}
            originFundValueUpdated={state.saldo_inicial}
            originFundValuePercentage={originFundValuePercentage}
            handleDecrementPercentage={handleDecrementPercentage}
            handleIncrementPercentage={handleIncrementPercentage}
            handleInputChangeOriginFund={handleInputChangeOriginFund}
          />
          <CardDestination
            parentRef={fundosDestinoRef}
            isOriginFundSelected={isOriginFundSelected}
            destinationFundSelectedList={fundosDestinoList}
            handleDecrementPercentage={handleDecrementPercentage}
            handleIncrementPercentage={handleIncrementPercentage}
            handleInputChangeDestinationFund={handleInputChangeDestinationFund}
          />
        </div>
        <div className="tw-mt-[10px] tw-w-full tw-flex tw-justify-center tw-border-t tw-border-[#9b9b9b] tw-shadow-md">
          <SubmitButtonSession
            isSubmitButtonDisabled={isSubmitButtonDisabled}
            handleModalConfirmation={handleModalConfirmation}
          />
        </div>
      </div>
      {isConfirmationModalForSubmitOpened && (
        <ConfirmationModal
          title="Movimentação"
          content="A movimentação que você realizará será processada hoje e não poderá ser revertida. Você confirma a movimentação?"
          negativeButtonText="Não"
          afirmativeButtonText="Sim"
          handleModalConfirmation={createSugestaoMovimentacao}
        />
      )}
      {isConfirmationModalForCancelOpened && (
        <ConfirmationModal
          title="Atenção"
          content="As movimentações de fundos registradas serão perdidas. Deseja Continuar?"
          negativeButtonText="Não"
          afirmativeButtonText="Sim"
          handleModalConfirmation={handleCancellationConfirmation}
        />
      )}
    </LayoutMovimentacaoFundos>
  );
};
